import { Boundaries } from "@planzone/core";
import { accessRestrictions } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  restrictions: accessRestrictions,
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(
  state: State,
  { restrictions }: Boundaries["retrieveAccessRestrictions"]["success"],
): State {
  return {
    request: setRequestStateToSuccess(),
    restrictions,
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    request: setRequestStateToFailure(),
  };
}

function handleEditionRequest(
  state: State,
  { nextRestrictions }: Boundaries["editAccessRestrictions"]["request"],
): State {
  return { ...state, restrictions: nextRestrictions };
}

function handleEditionSuccess(
  state: State,
  { restrictions }: Boundaries["editAccessRestrictions"]["success"],
): State {
  return { ...state, restrictions };
}

function handleEditionFailure(
  state: State,
  { restrictions }: Boundaries["editAccessRestrictions"]["failure"],
): State {
  return { ...state, restrictions };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveAccessRestrictionsRequested]: handleRequest,
    [events.retrieveAccessRestrictionsSucceeded]: handleSuccess,
    [events.retrieveAccessRestrictionsFailed]: handleFailure,
    [events.editAccessRestrictionsRequested]: handleEditionRequest,
    [events.editAccessRestrictionsSucceeded]: handleEditionSuccess,
    [events.editAccessRestrictionsFailed]: handleEditionFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
